const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

async function apiRequest(path, { method = 'GET', body } = {}) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: body ? JSON.stringify(body) : undefined
  });

  const text = await response.text();
  let payload = {};

  if (text) {
    try {
      payload = JSON.parse(text);
    } catch (error) {
      payload = { message: text };
    }
  }

  if (!response.ok) {
    throw new Error(payload.message || 'Request failed.');
  }

  return payload;
}

export function login(identity, password) {
  return apiRequest('/login', {
    method: 'POST',
    body: { identity, password }
  });
}

export function logout() {
  return apiRequest('/logout', {
    method: 'POST'
  });
}

export function createChecklist(data) {
  return apiRequest('/checklists', {
    method: 'POST',
    body: data
  });
}
